<template>
	<div class="workflow">
		<!-- 搜索栏 -->
		<div class="search-bar">
			<div class="search-left">
				<el-input v-model="queryParams.courseName" placeholder="标准课堂名称"
					style="width: 200px; margin-right: 10px;" clearable></el-input>

				<!-- 👉 新增：类型筛选 -->
				<el-select v-model="queryParams.aiModelTypeId" placeholder="请选择类型" style="width: 150px; margin-right: 10px;" clearable>
					<el-option label="工作流" :value="1"></el-option>
					<el-option label="智能体" :value="2"></el-option>
				</el-select>

				<el-button type="primary" icon="el-icon-search" @click="fetchData">搜索</el-button>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增标准课堂</el-button>
		</div>

		<!-- 数据表格 -->
		<el-table :data="tableData" border style="width: 100%; margin-top: 20px;" >
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
			<el-table-column prop="courseName" label="标准课堂名称" width="200" align="center"></el-table-column>

			<!-- 👉 新增：类型列 -->
			<el-table-column label="类型" width="100" align="center">
				<template slot-scope="scope">
					<el-tag :type="scope.row.aiModelTypeId === 1 ? 'primary' : 'info'">
						{{ scope.row.aiModelTypeId === 1 ? '工作流' : '智能体' }}
					</el-tag>
				</template>
			</el-table-column>

			<!-- 👉 新增：输入字段列 -->
			<el-table-column prop="inputParamKey" label="输入字段" width="140" align="center"></el-table-column>

			<el-table-column prop="remark" label="描述" show-overflow-tooltip align="center"></el-table-column>
			<!-- <el-table-column prop="aiModelTypeName" label="默认模型密钥名称" width="150" align="center"></el-table-column> -->
			<el-table-column prop="status" label="状态" width="100" align="center">
				<template slot-scope="scope" align="center">
					<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
						{{ scope.row.status === 0 ? '启用' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180" align="center">
				<template slot-scope="scope">
					{{ formatTime(scope.row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="250" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
					<el-button size="mini" type="warning" @click="handleStatus(scope.row)">
						{{ scope.row.status === 0 ? '禁用' : '启用' }}
					</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"
			style="margin-top: 20px; text-align: right;">
		</el-pagination>

		<!-- 新增/编辑弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
			<el-form :model="form" :rules="rules" ref="formRef" label-width="140px">

				<!-- 👉 新增：类型选择 -->
				<el-form-item label="类型" prop="aiModelTypeId">
					<el-radio-group v-model="form.aiModelTypeId">
						<el-radio :label="1">工作流</el-radio>
						<el-radio :label="2">智能体</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="标准课堂名称" prop="courseName">
					<el-input v-model="form.courseName" placeholder="请输入标准课堂名称"></el-input>
				</el-form-item>
				<!-- 👉 新增：大模型输入字段 -->
				<el-form-item label="输入参数字段" prop="inputParamKey">
					<el-input v-model="form.inputParamKey" placeholder="例如：input、prompt、question"></el-input>
				</el-form-item>

				<el-form-item label="描述" prop="remark">
					<el-input v-model="form.remark" type="textarea" :rows="4" placeholder="请输入描述"></el-input>
				</el-form-item>
				<el-form-item label="默认模型类型" prop="aiModelKeyId">
					<el-select v-model="form.aiModelKeyId" placeholder="请选择默认调用的模型密钥" style="width: 100%;">
						<el-option v-for="item in modelTypeList" :key="item.id" :label="item.platform"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-radio-group v-model="form.status">
						<el-radio :label="0">启用</el-radio>
						<el-radio :label="1">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'AiStandardCourse',
		data() {
			return {
				tableData: [],
				total: 0,
				modelTypeList: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					courseName: '',
					aiModelTypeId: null ,// 👉 新增
					remark:'',
				},
				dialogVisible: false,
				dialogTitle: '',
				form: {
					id: null,
					courseName: '',
					aiModelTypeId: 1, // 👉 新增
					
					aiModelKeyId: '', // 👉 新增
					remark: '',
					inputParamKey: null,
					status: 0,
					customPageId:1,
				},
				rules: {
					courseName: [{ required: true, message: '请输入标准课堂名称', trigger: 'blur' }],
					aiModelTypeId: [{ required: true, message: '请选择类型', trigger: 'change' }],
					
					aiModelKeyId: [{ required: true, message: '请输入参数字段', trigger: 'blur' }],
					inputParamKey: [{ required: true, message: '请选择默认模型类型', trigger: 'change' }]
				}
			}
		},
		methods: {
			formatTime(timestamp) {
				if (!timestamp) return ''
				return new Date(timestamp).toLocaleString()
			},

			// 获取模型类型
			async fetchModelTypeList() {
				this.modelTypeList=[]
				
				try {
					const  res = await this.API.get(this.API.admin.getModelKeyList, {
					pageNum: 1,
					pageSize: 100,
					keyName:'',
				})
					this.modelTypeList = res.data.data.records || []
					this.total = res.data.data.total || 0
				} catch (e) {}
			},

			// 获取工作流列表
			async fetchData() {
				
				try {
					const res = await this.API.get(this.API.admin.getStandardList,this.queryParams)
					this.tableData = res.data.data.records || []
					this.total = res.data.data.total || 0
					
					} catch (e) {
						this.tableData=[]
						this.total=0
					}
				
			},

			// 新增
			handleAdd() {
				this.dialogTitle = '新增标准课堂'
				this.form = {
					id: null,
					courseName: '',
					aiModelTypeId: 1,
					authToken: '',
					aiModelKeyId: '',
					remark: '',
					inputParamKey:'',
					status: 0
				}
				this.dialogVisible = true
			},

			// 编辑
			handleEdit(row) {
				this.dialogTitle = '编辑标准课堂'
				this.form = { ...row }
				this.dialogVisible = true
			},

			// 提交
			async handleSubmit() {
				// console.log(this.form)
				// return 
				this.$refs.formRef.validate(async valid => {
					if (!valid) return

					if (this.form.id) {
						await this.API.put(this.API.admin.putStandardUpdate, this.form)
						this.$message.success('修改成功')
					} else {
						await this.API.post(this.API.admin.postStandardAdd, this.form)
						this.$message.success('新增成功')
					}

					this.dialogVisible = false
					this.fetchData()
				})
			},

			// 修改状态
			async handleStatus(row) {
				const newStatus = row.status === 0 ? 1 : 0
				await this.API.put(this.API.admin.putStandardStatus + `/${row.id}?status=${newStatus}`)
				row.status = newStatus
				this.$message.success('状态已更新')
			},

			// 删除
			async handleDelete(row) {
				this.$confirm('确定删除该标准课堂？', '提示', { type: 'warning' }).then(async () => {
					await this.API.delete(this.API.admin.deleteStandardRemove + `/${row.id}`)
					this.$message.success('删除成功')
					this.fetchData()
				}).catch(() => {})
			},

			handleSizeChange(val) {
				this.queryParams.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val
				this.fetchData()
			},
			tolist(){
				this.fetchData()
				this.fetchModelTypeList()
			},
		},
		created() {
			this.tolist()
			
		}
	}
</script>

<style scoped>
	.workflow {
		padding: 20px;
		background-color: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search-left {
		display: flex;
		align-items: center;
	}
</style>